/** @deprecated use {@link request} */
export const fetchData = async <T>(apiUrl: string, query: string): Promise<T> => {
  try {
    const response = await fetch(`${apiUrl}?query=${query}&user=sxp`, {
      method: 'OPTIONS',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  } catch (error) {
    console.error(`Fetch failed: ${error}`)
    throw error
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postData = async <T>(apiUrl: string, body: Record<string, any>): Promise<T> => {
  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(body),
    })
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  } catch (error) {
    console.error(`Post failed: ${error}`)
    throw error
  }
}

type JSON = Record<string, unknown>

export type RequestConfig = {
  headers?: HeadersInit
  params?: string[][] | Record<string, string> | string | URLSearchParams
} & ({
  method?: 'GET'
  body?: null
} | {
  method: 'POST' | 'PATCH' | 'DELETE' | 'OPTIONS'
  body?: JSON | JSON[]
})

export type RequestResponse<T> = Omit<Response, 'json'> & {
  json(): Promise<T>
}

export async function request<T>(input: string | URL, config?: RequestConfig): Promise<RequestResponse<T>> {
  const url = new URL(input)

  const search = new URLSearchParams(config?.params)
  search.set('user', 'sxp')
  url.search = search.toString()

  const headers = new Headers(config?.headers)
  if (config?.body) headers.set('content-type', 'application/json')

  return await fetch(url.toString(), {
    method: config?.method,
    body: config?.body ? JSON.stringify(config.body) : null,
    headers,
  })
}
